import axios from "axios";

const module = {
    namespaced: true,
    state: {
        post: []
    },
    mutations: {
        setReport: (state, info) => {
            state.post = info
        }
    },

    actions: {
        async fetchReport({commit}, data) {
            const response = await axios.get(`admin/payments/report?from=${data.datePickerFrom}&to=${data.datePickerTo}`)
            commit('setReport', response.data.payments_report)
        }
    }
}
export default module